export const getReadConfig = (
  patientDetails,
  labels,
  setActiveAddress,
  setMode,
  providerCountryCode,
  isCarer = false,
) => {
  return {
    country: {
      code: providerCountryCode || 'US',
    },
    showAdd: true,
    showAddButton: true,
    hideActionBar: true,
    onAdd: () => {},
    // Disable context menu for carer addresses by setting mode to 'readOnly'
    mode: isCarer ? 'readOnly' : undefined,
    contextMenu: isCarer
      ? undefined
      : [
          {
            text: labels['labels.common.edit'],
            onclick: (item) => {
              setActiveAddress(item);
              setMode('update');
            },
            icon: 'edit',
          },
        ],
    contextMenuSize: 'large',
  };
};

export const getEditConfig = (
  handleOnChange,
  providerCountryCode,
  googleMapsApiKey,
) => {
  const isChinaRegion = providerCountryCode === 'CN';

  return {
    country: {
      code: providerCountryCode || 'US',
    },
    countrySelector: {
      lockCountry: true,
      hideCountry: true,
    },
    googleMapsApiKey,
    disableGoogleMapsApi: isChinaRegion,
    disableLiveValidation: true,
    onChange: handleOnChange,
  };
};
